import { useEffect } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

import { useInitCommunication } from './useInitCommunication';
import { useGeofencingHandler } from './useGeofencingHandler';
import { useRequestNativePacket } from './useRequestNativePacket';
import { useOnError } from './useOnError';

export const useNativeIntegration = ({
    sdk,
    enable,
    license,
    identifierType,
    transactionID,
    userId,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket,
    triggerGeolocation,
    reasonRef
}) => {
    const initClientSDK = useInitCommunication();
    const requestNativePacket = useRequestNativePacket({ license, transactionID, userId, identifierType, reasonRef });
    const onError = useOnError({ transactionID, setShowOverlay, useTransparentPopup });

    useGeofencingHandler({
        triggerGeolocation,
        receivePacket,
        onConnect,
        onError
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        htcmdService.sendMessage('geofencingsupported');
    }, [
        sdk,
        enable
    ]);

    return { requestNativePacket, initClientSDK };
};
